module.exports = __webpack_public_path__ + "img/new-brand.ccfc1f6a.png";